export default __webpack_public_path__ + "static/media/06.47.3913566e.jpg";